import { Icon } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import iconCallHistoryDark900 from '~/assets/icons-light-theme/icon-callHistory-dark900.svg?react'
import iconFaxingDark900 from '~/assets/icons-light-theme/icon-faxing-dark900.svg?react'
import iconTextingDark900 from '~/assets/icons-light-theme/icon-texting-dark900.svg?react'
import IconPlus from '~/assets/svgs/icon-plus.svg?react'
import { useModalState } from '~/atoms/ModalState'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import { DropdownActionButton } from '~/components/shared/Dropdown/DropdownActionButton'
import { MenuItem, MenuListItem } from '~/components/shared/Dropdown/MenuItem'

import { ActionsButtonStyleValues } from './componentStyles/ActionsButton.style'

const tooltipText = 'New Action'
const ActionsButton = () => {
  const {
    faxModal: [faxModalState, setFaxModalState],
    messagingModal: [, setMessagingModalState],
    callModal: [, setCallModalState],
  } = useModalState()

  const handleCreateNewChat = () => {
    setMessagingModalState({ open: true })
    window.gtag('event', 'new_thread_modal_opened', {})
  }

  const handleOpenCallModal = () => {
    setCallModalState({ open: true })
    window.gtag('event', 'new_call_modal_opened', {})
  }

  const handleOpenNewFax = () => {
    setFaxModalState({
      ...faxModalState,
      open: true,
      number: '',
    })
    window.gtag('event', 'new_fax_modal_opened', {})
  }

  const getMenuItem = (
    primaryText: string,
    leftIcon: SVGComponent,
    onClick: () => void,
  ) => {
    return {
      value: primaryText,
      content: (
        <MenuListItem
          primaryText={primaryText}
          leftContent={<Icon as={leftIcon} />}
        />
      ),
      onSelect: onClick,
    } as MenuItem<string>
  }

  const menuItemData = useMemo(() => {
    return [
      {
        onClick: () => handleCreateNewChat(),
        icon: iconTextingDark900,
        text: 'New Thread',
      },
      {
        onClick: () => handleOpenCallModal(),
        icon: iconCallHistoryDark900,
        text: 'New Call',
      },
      {
        onClick: () => handleOpenNewFax(),
        icon: iconFaxingDark900,
        text: 'New Fax',
      },
    ]
  }, [])

  const menuItems = useMemo(
    () =>
      menuItemData.map((item) =>
        getMenuItem(item.text, item.icon, item.onClick),
      ),
    [],
  )

  return (
    <DropdownActionButton
      variant={QuickActionButtonVariants.Default_400}
      tooltipText={tooltipText}
      icon={IconPlus}
      items={menuItems}
      menuOptions={{ width: ActionsButtonStyleValues.width }}
    />
  )
}

export { ActionsButton }
